import { render, staticRenderFns } from "./LinkTabBar.vue?vue&type=template&id=52c52936"
import script from "./LinkTabBar.vue?vue&type=script&lang=js"
export * from "./LinkTabBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports